<template>
    <section class="gradient-custom">
        <div class="container my-5 py-5">
            <img v-bind:src="require('@/assets/logo_dark.png')" alt="Responsive image" style="width: 200px;">
            <div class="row d-flex justify-content-center py-5">
                <div class="col-md-7 col-lg-7 col-xl-8">
                    <div class="card" style="border-radius: 15px;">
                        <div class="card-body">
                            <h5 class="card-title" siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default">Check Nickname</h5>
                            <span class="border-bottom"></span>
                            <h6 align="left" class="card-title" siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default">Nickname</h6>
                            <input type="text" id="typeName" class="form-control form-control-lg" siez="17" aria-label="Default" aria-describedby="inputGroup-sizing-default" v-model="query" @keydown="checkForSpaces">
                            <br>
                            <p align="left">*Only applies to Android and iOS users see <a href="https://napoleon.chat/terminos-condiciones" style="color:#d7a952;" target="_blank">terms and conditions</a></p>
                            <a href="https://napoleon.chat/" type="button" class="btn btn-outline-dark">Back</a>&nbsp;&nbsp;
                            <button type="button" class="btn btn-outline-warning" :disabled="isInputEmpty" v-on:click="getUsers">Search</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import { getLastPaymentV8 } from '@/modules/payments/aplication/getLastPayment';
import { PaymentRepository } from '@/modules/payments/infraestructure/PaymentRepository';
import { getUser } from '@/modules/users/aplication/getUser';
import { getUserById } from '@/modules/users/aplication/getUserById';
import { UserRepository } from '@/modules/users/infraestructure/UserRepository';
import store from '@/store';

export default {
    name: 'SearchComponent',
    data() {
        return {
            query: '',
            posts: [],
            user: '',
            idUser: 0,
            serve: '',
        }
    },
    computed: {
        isInputEmpty(){
            return !this.query;
        },
    },
    mounted() {
        this.validParams()
    },
    methods: {
        async getUsers(id = 0) {
            store.commit('setLoad', true)
            let data = null
            if (id > 0) {
                data = await getUserById(UserRepository(), id)
                data.nick_name = data.nick
            }
            if (this.query.length > 3) {
                data = await getUser(UserRepository(), this.query.toLowerCase())
            }
            if (data != null) {
                store.commit('setUser', {
                    nick: data.nick_name,
                    id: data.id
                })
                this.getPayment(data.nick_name, data.id)
                return
            }
            store.commit('setLoad', false)
        },

        async getPayment(nick) {
            let data = await getLastPaymentV8(PaymentRepository(), nick)
            if (data != null) {
                store.commit('setExpired', data.expire_at)
                this.$router.push({ name: 'active' })
                return
            }
            this.$router.push({ name: 'unsubscribed' })
        },

        checkForSpaces(event) {
            if (event.key === ' ' || event.code === 'Space') {
                event.preventDefault();
            }
        },

        validParams() {
            const id = this.$route.params.id;
            if (this.isNumber(id)) {
                store.commit('setLoad', true)
                const idNumber = Number(id);
                if (idNumber > 0) {
                    return this.getUsers(idNumber);
                }
                store.commit('setLoad', false)
            }
        },

        isNumber(valor) {
            return Number.isInteger(Number(valor));
        }
    },
}
</script>